var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.customerInfo, function (item, index) {
    return _c('b-row', {
      key: index,
      staticClass: "mb-1"
    }, [_c('b-col', {
      staticClass: "d-flex justify-content-between mb-2",
      attrs: {
        "cols": "4"
      }
    }, [_vm._v(" " + _vm._s(item.label) + " "), _c('span', [_vm._v(":")])]), _c('b-col', {
      attrs: {
        "cols": "8"
      }
    }, [_vm._v(" " + _vm._s(item.value) + " ")])], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }